import { render, staticRenderFns } from "./ImportExpenseDialog.vue?vue&type=template&id=4373b5f6&scoped=true"
import script from "./ImportExpenseDialog.vue?vue&type=script&lang=js"
export * from "./ImportExpenseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4373b5f6",
  null
  
)

export default component.exports